export const UA_FORM: { [propKey: string]: any } = {
    start_initial_form_dialogue_ua: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Доброго дня, я розумію, що Bи хотіли б отримати пораду щодо пошуку роботи чи професійного навчання в Німеччині. Запис на консультацію відбувається на місці у Bашому місцевому центрі зайнятості. Прийом є добровільним та безкоштовним.Для Bашого призначення нам потрібна Bаша інформація. Наприклад, про Bаше резюме та Bашу кваліфікацію.",
            },
            {
                type: "defaultText",
                text: "Щоб переконатися, що Bи правильно заповнили анкету, у мене є заздалегідь кілька запитань до Bас.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Ok",
                    type: "button",
                    suggestion: [
                        {
                            title: "Ok",
                            payload: "is_refugee",
                            type: "button",
                        },
                    ],
                },
            ],
        },
    },
    is_refugee: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Ви втекли від війни в Україні і шукаєте захисту y Німеччині?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Refugee",
                    type: "button",
                    suggestion: [
                        {
                            title: "Так",
                            payload: "form_initial_address",
                            type: "button",
                            german: "Ja",
                            theme: "left",
                        },
                        {
                            title: "Ні",
                            payload: "no_refugee",
                            type: "button",
                            german: "Nein",
                            theme: "right",
                        },
                    ],
                },
            ],
        },
    },
    form_initial_address: {
        botId: "FORM",
        messages: [
            {
                type: "infoText",
                text: "Мені потрібна Ваша (поточна) адреса проживання у Німеччині, щоб визначити, чи є ми правильним контактом для Вас для консультування щодо роботи та кар’єри, і щоб ми могли зв’язатися з Вами у майбутньому, якщо це буде необхідно.",
                info: "Повна адреса важлива для того, щоб вас могли направити до відповідного центру зайнятості. Тому що мешканців однієї вулиці іноді розподіляють на різні центри зайнятості залежно від номера будинку.<br><br>Якщо Ваша адреса проживання зміниться в майбутньому, Ви можете вказати це онлайн на нашій сторінці повідомлень про зміни.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Вулиця * (Латиницею)",
                    type: "formInput",
                    german: "Straße",
                },
                {
                    name: "Номер дому * (Латиницею)",
                    type: "formInput",
                    german: "Hausnummer",
                },
                {
                    name: "Суфікс адреси (Латиницею)",
                    type: "formInput",
                    german: "Adresszusatz",
                },
                {
                    name: "Індекс * (Латиницею)",
                    type: "formInput",
                    german: "Postleitzahl",
                },
                {
                    name: "Місто * (Латиницею)",
                    type: "formInput",
                    german: "Ort",
                },
                {
                    name: "Країна (Латиницею)",
                    type: "formInput",
                    default: "Deutschland (Nimechchyna)",
                    german: "Land",
                },
                {
                    title: "Підтвердити адресу",
                    icon: "icon-left",
                    theme: "dark",
                    payload: "get_jobcenter",
                    type: "formButton",
                    pageName: "Adresse",
                },
            ],
        },
    },
    no_refugee: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Ця форма профорієнтації розроблена спеціально для людей, які втекли з України через війну.",
            },
            {
                type: "defaultText",
                text: "Ви вже працюєте в Німеччині і хотіли б професійно переорієнтуватися? Тоді Ви знайдете додаткову інформацію у Центрі кар’єрної інформації. Інформацію про подальше навчання можна знайти в розділі «Професійне навчання». Якщо Вам потрібна порада щодо пошуку роботи чи професійного навчання у Німеччині, Ви можете знайти більше інформації тут. Якщо Ви приїхали з-за кордону і шукаєте роботу, Ви можете знайти більше інформації на сторінці: Пошук роботи та стажування в Німеччині. Ви вже працюєте в Німеччині і хотіли б професійно переорієнтуватися? Тоді Ви знайдете додаткову інформацію у Центрі кар’єрної інформації. Інформацію про подальше навчання можна знайти в розділі «Професійне навчання». Ви щойно закінчили школу, тренінг чи навчання і шукаєте інформацію про професійну орієнтацію чи допомогу у виборі курсу чи тренінгу? Тоді Ви можете знайти більше інформації за адресою: Особиста кар’єрна порада.",
            },
        ],
    },
    get_jobcenter: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Дуже добре, Ви живете в районі, де ми можемо порекомендовати Вас щодо роботи та професійного навчання. Ваш відповідальний центр зайнятості: -- Jobcenter Daten",
            },
            {
                type: "defaultText",
                text: "Ви вже записалися на консультацію у цей центр зайнятості?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "FormBTN",
                    type: "button",
                    suggestion: [
                        {
                            title: "Так",
                            payload: "question_form_1",
                            type: "button",
                            theme: "left",
                        },
                        {
                            title: "Ні",
                            payload: "question_form_2",
                            type: "button",
                            theme: "right",
                        },
                    ],
                },
            ],
        },
    },
    question_form_1: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Чудово, тоді ми можемо почати безпосередньо з анкети.",
            },
            {
                type: "infoText",
                text: "Зазвичай на заповнення анкети йде близько 15-20 хвилин. <br><br> Підготуйте наступне:<br><ul><li>Резюме</li><li>Документи на проживання</li></ul>",
                info: "Зауважте, що з міркувань захисту даних я можу зберігати статус завершення на вашому пристрої лише протягом 24 годин.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    title: "Прийняти та далі",
                    icon: "icon-right",
                    payload: "start_form_dialogue_ua",
                    type: "formButton",
                    theme: "dark",
                    pageName: "StartFormular",
                    stage: "Personal",
                },
            ],
        },
    },
    question_form_2: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Це не проблема, Ви все одно можете заповнити анкету, а потім домовитися про зустріч у місцевому центрі зайнятості.",
            },
            {
                type: "infoText",
                text: "Зазвичай на заповнення анкети йде близько 15-20 хвилин. <br><br> Підготуйте наступне:<br><ul><li>Резюме</li><li>Документи на проживання</li></ul>",
                info: "Зауважте, що з міркувань захисту даних я можу зберігати статус завершення на вашому пристрої лише протягом 24 годин.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    title: "Прийняти та далі",
                    icon: "icon-right",
                    payload: "start_form_dialogue_ua",
                    type: "form",
                    theme: "dark",
                    pageName: "StartFormular",
                    stage: "Personal",
                },
            ],
        },
    },
    start_form_dialogue_ua: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Для того, щоб мати можливість правильно проконсультувати Вас, нам в агентстві з працевлаштування потрібна Ваша особиста інформація.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Ім‘я (Латиницею)",
                    type: "formInput",
                    german: "Vorname",
                },
                {
                    name: "Прізвище (Латиницею)",
                    type: "formInput",
                    german: "Nachname",
                },
                {
                    name: "Дівоче прізвище (Латиницею)",
                    type: "formInput",
                    german: "Geburtsname",
                },
                {
                    name: "Дата нарождення",
                    type: "formDate",
                    german: "Geburtsdatum",
                },
                {
                    name: "Стать",
                    type: "radioButton",
                    german: "Geschlecht",
                    choice: [
                        {
                            title: "жіноча",
                            payload: "жіноча",
                            german: "weiblich",
                        },
                        {
                            title: "чоловіча",
                            payload: "чоловіча",
                            german: "männlich",
                        },
                        {
                            title: "різний",
                            payload: "різний",
                            german: "weiblich",
                        },
                        {
                            title: "немає інформації",
                            payload: "немає інформації",
                            german: "Keine Angabe",
                        },
                    ],
                },
                {
                    name: "Громадянство",
                    type: "formDropdown",
                    german: "Staatsangehörigkeit",
                    placeholder: "- будь ласка, оберіть -",
                    choice: [
                        {
                            title: "Німеччина",
                            payload: "Німеччина",
                            german: "Deutsch",
                        },
                        {
                            title: "Україна",
                            payload: "Україна",
                            german: "Ukrainisch",
                        },
                        {
                            title: "Інше",
                            payload: "Інше",
                            german: "Andere",
                        },
                    ],
                },
                {
                    title: "Підтвердити введену інформацію",
                    icon: "icon-left",
                    payload: "form_ua_2",
                    type: "formButton",
                    pageName: "PersonalData",
                    theme: "dark",
                },
            ],
        },
    },
    form_ua_2: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Щоб краще зрозуміти Вашу особисту ситуацію, Ви можете надати тут інформацію про Ваші умови проживання.",
            },
            {
                type: "defaultText",
                text: "У якій життєвій ситуації Ви перебуваєте на даний момент?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Status",
                    type: "button",
                    suggestion: [
                        {
                            title: "неодружена / неодружений",
                            payload: "form_ua_3",
                            type: "button",
                            german: "allein stehend",
                        },
                        {
                            title: "громадський шлюб",
                            payload: "form_ua_3",
                            type: "button",
                            german: "eheähnliche/häusliche Gemeinschaft",
                        },
                        {
                            title: "у шлюбі",
                            payload: "form_ua_3",
                            type: "button",
                            german: "verheiratet",
                        },
                        {
                            title: "немає інформації",
                            payload: "form_ua_3",
                            type: "button",
                            german: "Keine Angabe",
                        },
                    ],
                },
            ],
        },
    },
    form_ua_3: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Добре, а чи є у вас (пасинки) / діти?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Kinder",
                    type: "button",
                    suggestion: [
                        {
                            title: "так",
                            payload: "form_ua_4",
                            type: "button",
                            german: "Ja",
                        },
                        {
                            title: "ні",
                            payload: "form_ua_6",
                            type: "button",
                            german: "Nein",
                        },
                        {
                            title: "немає інформації",
                            payload: "form_ua_6",
                            type: "button",
                            german: "Keine Angabe",
                        },
                    ],
                },
            ],
        },
    },
    form_ua_4: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Коли день народження у Вашої наймолодшої дитини?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "День народження",
                    german: "Geburtstag",
                    type: "formDate",
                },
                {
                    title: "Підтвердити дату народження",
                    icon: "icon-left",
                    payload: "form_ua_5",
                    type: "formButton",
                    pageName: "Geburtstag_J_Kind",
                    theme: "dark",
                },
            ],
        },
    },
    form_ua_5: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Скільки дітей віком до 15 років проживає у Вашій родині?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Kinderanzahl",
                    type: "button",
                    suggestion: [
                        {
                            title: "1",
                            payload: "form_ua_6",
                            type: "button",
                        },
                        {
                            title: "2",
                            payload: "form_ua_6",
                            type: "button",
                        },
                        {
                            title: "3",
                            payload: "form_ua_6",
                            type: "button",
                        },
                        {
                            title: "4",
                            payload: "form_ua_6",
                            type: "button",
                        },
                        {
                            title: "більше ніж 4",
                            payload: "form_ua_6",
                            type: "button",
                            german: "mehr als 4",
                        },
                        {
                            title: "немає інформації",
                            payload: "form_ua_6",
                            type: "button",
                            german: "Keine Angabe",
                        },
                    ],
                },
            ],
        },
    },
    form_ua_6: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Тепер щодо мобільності: у Вас є водійські права?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Führerschein",
                    type: "button",
                    suggestion: [
                        {
                            title: "так",
                            payload: "form_ua_7",
                            type: "button",
                            german: "Ja",
                        },
                        {
                            title: "ні",
                            payload: "form_ua_8",
                            type: "button",
                            german: "Nein",
                        },
                        {
                            title: "немає інформації",
                            payload: "form_ua_8",
                            type: "button",
                            german: "Keine Angabe",
                        },
                    ],
                },
            ],
        },
    },
    form_ua_7: {
        botId: "FORM",
        messages: [
            {
                type: "infoText",
                text: "Який клас водійських прав у Вас є?",
                info: "Класи водійських прав чи водійський дозвіл визначають, яким типом моторизованих транспортних засобів Вам дозволено керувати. Для деяких робіт посвідчення водія на певні транспортні засоби є необхідними або є перевагою. Для отримання додаткової інформації див. “Курси водіння”.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Клас водійських прав",
                    german: "Führerscheinklasse",
                    type: "formInput",
                    infoString: "наприклад, клас А, B, C, D",
                },
                {
                    title: "Підтвердити клас водійських прав",
                    icon: "icon-left",
                    payload: "form_ua_9",
                    type: "formButton",
                    pageName: "Führerscheinklasse",
                    theme: "dark",
                },
            ],
        },
    },
    form_ua_8: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Зрозуміло! Переходимо безпосередньо до Ваших контактів.",
            },
            {
                type: "defaultText",
                text: "Якщо Ви зараз маєте лише тимчасове житло в Німеччині, нам допоможе, якщо Ви наддасте свій номер (мобільного) телефону та/або електронну адресу. Ця інформація є добровільною. Ми обробляємо Ваші контактні дані конфіденційно і ніколи не передаємо їх третім особам.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "(Мобільний) номер телефону (необов'язково)",
                    type: "formInput",
                    german: "(Mobil-)Telefonnummer (optional)",
                    infoString: "Будь-ласка, введіть код країни, наприклад +49",
                },
                {
                    name: "E-Mail (необов'язково)",
                    type: "formInput",
                    german: "E-Mail (optional)",
                },
                {
                    name: "Примітки щодо контакту з Вами(необов'язково)",
                    type: "formText",
                    german: "Anmerkungen zur Kontaktaufnahme (optional)",
                },
                {
                    title: "Підтвердити контактні дані та далі ->",
                    icon: "icon-left",
                    payload: "form_ua_10",
                    type: "formButton",
                    pageName: "Kontaktdaten",
                    theme: "dark",
                    stage: "Document",
                },
            ],
        },
    },
    form_ua_9: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Якщо Ви зараз маєте лише тимчасове житло в Німеччині, нам допоможе, якщо Ви наддасте свій номер (мобільного) телефону та/або електронну адресу. Ця інформація є добровільною. Ми обробляємо Ваші контактні дані конфіденційно і ніколи не передаємо їх третім особам.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "(Мобільний) номер телефону (необов'язково)",
                    type: "formInput",
                    infoString: "Будь-ласка, введіть код країни, наприклад +49",
                },
                {
                    name: "E-Mail (необов'язково)",
                    type: "formInput",
                },
                {
                    name: "Примітки щодо контакту з Вами(необов'язково)",
                    type: "formText",
                },
                {
                    title: "Підтвердити контактні дані та далі ->",
                    icon: "icon-left",
                    payload: "form_ua_10",
                    type: "formButton",
                    pageName: "Kontaktdaten",
                    theme: "dark",
                    stage: "Document",
                },
            ],
        },
    },
    form_ua_10: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "UmЩоб мати можливість оцінити, чи можете Ви працювати у Німеччині, і якщо так, то яку роботу Ви можете отримати у Німеччині, нам потрібна інформація про Ваш статус проживання у Німеччині.",
            },
            {
                type: "infoText",
                text: "Який у Вас вид на проживання?",
                info: "Ви можете знайти свій дозвіл на проживання у документах на проживання, які Ви отримали від імміграційних органів. Ви можете знайти більше інформації у розділі в’їзд, перебування та повернення на сайті Germany4ukraine.de",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Visumangabe",
                    type: "button",
                    suggestion: [
                        {
                            title: "Aufenthaltserlaubnis §24 AufenthG",
                            payload: "form_ua_11",
                            type: "button",
                            german: "Aufenthaltserlaubnis §24 AufenthG",
                        },
                        {
                            title: "Європейська віза",
                            payload: "form_ua_11",
                            type: "button",
                            german: "EU-Visum",
                        },
                        {
                            title: "дозволений допуск",
                            payload: "form_ua_11",
                            type: "button",
                            german: "gestattete Duldung",
                        },
                        {
                            title: "дозвіл на постійне проживання",
                            payload: "form_ua_11",
                            type: "button",
                            german: "Niederlassungserlaubnis",
                        },
                        {
                            title: "Інше",
                            payload: "form_ua_10_1",
                            type: "button",
                            german: "Sonstige",
                        },
                        {
                            title: "Я не знаю",
                            payload: "form_ua_10_2",
                            type: "button",
                            german: "Ich weiß es nicht",
                        },
                    ],
                },
            ],
        },
    },
    form_ua_10_1: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Який у вас дозвіл на проживання?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Посвідка на проживання",
                    german: "Aufenthaltstitel",
                    type: "formInput",
                },
                {
                    title: "Підтвердити дозвіл на проживання",
                    icon: "icon-left",
                    payload: "form_ua_11",
                    type: "formButton",
                    pageName: "Aufenthaltstitel",
                    theme: "dark",
                },
            ],
        },
    },
    form_ua_10_2: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Ви можете знайти свій дозвіл на проживання у документах на проживання, які Ви отримали від імміграційних органів. Ви можете знайти більше інформації у розділі в’їзд, перебування та повернення на сайті Germany4ukraine.de.",
            },
            {
                type: "defaultText",
                text: "Важливо, щоб Ви взяли з собою на консультацію деталі свого дозволу на проживання. Ваш вид на проживання визначає, які можливості Ви маєте на німецькому ринку праці.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Aufenthaltstitel",
                    type: "button",
                    suggestion: [
                        {
                            title: "Введіть дані про дозвіл на проживання",
                            payload: "form_ua_10",
                            type: "button",
                        },
                        {
                            title: "Доповнити дані про дозвіл на проживання",
                            payload: "form_ua_13",
                            type: "button",
                            stage: "Education",
                        },
                    ],
                },
            ],
        },
    },
    form_ua_11: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "До якого часу дійсна Ваш дозвіл на проживання?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Термін дії",
                    type: "formDate",
                    german: "Gültigkeitsdatum",
                },
                {
                    name: "Термін дії",
                    type: "radioButton",
                    german: "Gültigkeitsdatum",
                    choice: [
                        {
                            title: "необмежено",
                            payload: "необмежено",
                            german: "unbefristet",
                        },
                        {
                            title: "Немає інформації",
                            payload: "Немає інформації",
                            german: "Keine Angabe",
                        },
                    ],
                },
                {
                    title: "Підтвердити термін дії",
                    icon: "icon-left",
                    payload: "form_ua_12",
                    type: "formButton",
                    pageName: "Gültigkeitsdatum",
                    theme: "dark",
                },
            ],
        },
    },
    form_ua_12: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Що зазначено про працевлаштування у Вашому дозволі на працевлаштування?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Arbeitserlaubnis",
                    type: "button",
                    suggestion: [
                        {
                            title: "Працевлаштування дозволено",
                            payload: "form_ua_13",
                            type: "button",
                            german: "Erwerbstätigkeit gestattet",
                            stage: "Education",
                        },
                        {
                            title: "Зайнятість дозволена",
                            payload: "form_ua_13",
                            type: "button",
                            german: "Beschäftigung gestattet",
                            stage: "Education",
                        },
                        {
                            title: "працевлаштування з дозволом від органу іноземців",
                            payload: "form_ua_13",
                            type: "button",
                            german: "Beschäftigung mit Erlaubnis der Ausländerbehörde",
                            stage: "Education",
                        },
                        {
                            title: "Зайнятість не дозволена",
                            payload: "form_ua_13",
                            type: "button",
                            german: "Erwerbstätigkeit nicht gestattet",
                            stage: "Education",
                        },
                        {
                            title: "Інше",
                            payload: "form_ua_12_1",
                            type: "button",
                            german: "Sonstiges",
                        },
                        {
                            title: "Немає інформації",
                            payload: "form_ua_12_2",
                            type: "button",
                            german: "keine Angabe",
                        },
                    ],
                },
            ],
        },
    },
    form_ua_12_1: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Що вказано у Вашому дозволі на проживання про зайнятість?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Займана посада",
                    german: "Erwerbstätigkeitstitel",
                    type: "formInput",
                },
                {
                    title: "Підтвердити введені дані",
                    icon: "icon-left",
                    payload: "form_ua_13",
                    type: "formButton",
                    pageName: "Erwerbstätigkeitstitel",
                    theme: "dark",
                    stage: "Education",
                },
            ],
        },
    },
    form_ua_12_2: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Важливо взяти з собою на консультацію деталі про зайнятість. Він визначає, які можливості ви маєте на німецькому ринку праці.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Erwerbstätigkeitstitel",
                    type: "button",
                    suggestion: [
                        {
                            title: "Надати інформацію про зайнятість",
                            payload: "form_ua_10",
                            type: "button",
                        },
                        {
                            title: "Підтвердити інформацію про зайнятість",
                            payload: "form_ua_13",
                            type: "button",
                            stage: "Education",
                        },
                    ],
                },
            ],
        },
    },
    form_ua_13: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "UmЩоб разом з Вами знайти відповідну роботу, потрібна точна інформація про Ваш навчальний заклад і, якщо це можливо, академічну освіту.",
            },
            {
                type: "defaultText",
                text: "У Вас є шкільна освіта?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Schulabschluss",
                    type: "button",
                    suggestion: [
                        {
                            title: "так",
                            payload: "form_ua_14",
                            type: "button",
                            german: "Ja",
                        },
                        {
                            title: "ні",
                            payload: "form_ua_14",
                            type: "button",
                            german: "Nein",
                        },
                        {
                            title: "немає інформації",
                            payload: "form_ua_14",
                            type: "button",
                            german: "keine Angabe",
                        },
                    ],
                },
            ],
        },
    },
    form_ua_14: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Ви отримували освіту?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Studienabschluss",
                    type: "button",
                    suggestion: [
                        {
                            title: "немає освіти",
                            payload: "form_ua_16",
                            type: "button",
                            german: "kein Studium",
                        },
                        {
                            title: "Закінчена освіта",
                            payload: "form_ua_15",
                            type: "button",
                            german: "Studium mit Abschluss",
                        },
                        {
                            title: "Незакінчена освіта",
                            payload: "form_ua_14_1",
                            type: "button",
                            german: "Studium ohne Abschluss",
                        },
                        {
                            title: "немає інформації",
                            payload: "form_ua_16",
                            type: "button",
                            german: "keine Angabe",
                        },
                    ],
                },
            ],
        },
    },
    form_ua_14_1: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Добре, будь ласка, вкажіть мені свою спеціальність і скільки часу Ви навчалися.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Тема",
                    german: "Studienfach",
                    type: "formInput",
                    infoString:
                        "наприклад, бакалавр маркетингу 5 семестрів, магістр хімії 2 семестри",
                },
                {
                    title: "Підтвердити інформацію про освіту",
                    icon: "icon-left",
                    payload: "form_ua_16",
                    type: "formButton",
                    pageName: "Studienfach",
                    theme: "dark",
                },
            ],
        },
    },
    form_ua_15: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Гаразд, вкажіть, будь ласка, Ваші наукові ступені та напрямок навчання.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Вивчення",
                    german: "Studium",
                    type: "formInput",
                    infoString:
                        "наприклад, бакалавр бізнес, магістр маркетингу",
                },
                {
                    title: "Підтвердити інформацію про освіту",
                    icon: "icon-left",
                    payload: "form_ua_16",
                    type: "formButton",
                    pageName: "Studium",
                    theme: "dark",
                },
            ],
        },
    },
    form_ua_16: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Добре, у Вас є закінчена середня спеціальна освіта?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Ausbildung",
                    type: "button",
                    suggestion: [
                        {
                            title: "немає середньої спеціальної освіти",
                            payload: "form_ua_18",
                            type: "button",
                            german: "keine Berufsausbildung",
                        },
                        {
                            title: "закінчена середня спеціальна освіта",
                            payload: "form_ua_17",
                            type: "button",
                            german: "Berufsausbildung mit Abschluss",
                        },
                        {
                            title: "незакінчена середня спеціальна освіта",
                            payload: "form_ua_16_1",
                            type: "button",
                            german: "Berufsausbildung ohne Abschluss",
                        },
                        {
                            title: "немає інформації",
                            payload: "form_ua_18",
                            type: "button",
                            german: "keine Angabe",
                        },
                    ],
                },
            ],
        },
    },
    form_ua_16_1: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Добре, вкажіть, будь ласка, спеціальність і скільки часу Ви навчалися.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Професійне навчання",
                    german: "Berufsausbildung",
                    type: "formInput",
                    infoString: "Наприклад, пекар 1,5 роки, кресляр 2,5 роки",
                },
                {
                    title: "Підтвердити інформацію про освіту",
                    icon: "icon-left",
                    payload: "form_ua_18",
                    type: "formButton",
                    pageName: "Berufsausbildung",
                    theme: "dark",
                },
            ],
        },
    },
    form_ua_17: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Дуже добре, будь ласка, скажіть мені напрямок навчання та Вашу професійну кваліфікацію.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Професійна кваліфікація",
                    german: "Berufsausbildung",
                    type: "formInput",
                    infoString:
                        "наприклад, пекар (майстер), кресляр (підмайстр)",
                },
                {
                    title: "Підтвердити інформацію про освіту",
                    icon: "icon-left",
                    payload: "form_ua_18",
                    type: "formButton",
                    pageName: "Berufsausbildung",
                    theme: "dark",
                },
            ],
        },
    },
    form_ua_18: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Яку роботу Ви б хотіли мати у Німеччині?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Бажана робота",
                    german: "Wunschjob",
                    type: "formText",
                    infoString:
                        "наприклад, я хотів би працювати офісним клерком у харчовій промисловості ...",
                },
                {
                    title: "Підтвердити інформації",
                    icon: "icon-left",
                    payload: "form_ua_19",
                    type: "formButton",
                    pageName: "WunschJob",
                    theme: "dark",
                },
            ],
        },
    },
    form_ua_19: {
        botId: "FORM",
        messages: [
            {
                type: "infoText",
                text: "Будь ласка, надайте своє резюме з відповідною кваліфікацією та досвідом роботи.",
                info: "Ваші записи автоматично відображаються у хронологічному порядку. Ви можете ввести до 15 видів діяльності.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Вид діяльності",
                    type: "formDropdown",
                    german: "Tätigkeitsart",
                    placeholder: "- будь ласка, оберіть -",
                    choice: [
                        {
                            title: "Шкільна освіта",
                            payload: "Шкільна освіта",
                            german: "Schule",
                        },
                        {
                            title: "Навчання",
                            payload: "Навчання",
                            german: "Ausbildung",
                        },
                        {
                            title: "Професійно-технічна освіта",
                            payload: "Професійно-технічна освіта",
                            german: "Fachhochschule",
                        },
                        {
                            title: "Вища освіта",
                            payload: "Вища освіта",
                            german: "Hochschule (Universität)",
                        },
                        {
                            title: "Практика",
                            payload: "Практика",
                            german: "Praktikum",
                        },
                        {
                            title: "Робота",
                            payload: "Робота",
                            german: "Beschäftigung",
                        },
                        {
                            title: "Інше",
                            payload: "Інше",
                            german: "Sonstiges",
                        },
                    ],
                },
                {
                    name: "Початок діяльности",
                    type: "formDate",
                    german: "Tätigkeitsstart",
                },
                {
                    name: "Кінець діяльності",
                    type: "formDate",
                    german: "Tätigkeitsende",
                },
                {
                    name: "Назва діяльності",
                    type: "formInput",
                    german: "Name der Tätigkeitsstätte",
                },
                {
                    name: "Місто діяльності",
                    type: "formInput",
                    german: "Tätigkeitsort (Stadt, Land)",
                },
                {
                    name: "Опис діяльності / Кваліфікація",
                    type: "formText",
                    german: "Tätigkeitsbeschreibung/Qualifikation",
                },
                {
                    title: "Відмінити діяльність",
                    icon: "icon-left-x",
                    payload: "form_ua_19",
                    type: "formButton",
                },
                {
                    title: "Підтвердити діяльність",
                    icon: "icon-left",
                    payload: "form_ua_20",
                    type: "formButton",
                    pageName: "Education",
                    theme: "dark",
                },
            ],
        },
    },
    form_ua_19_1: {
        botId: "FORM",
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Вид діяльності",
                    type: "formDropdown",
                    german: "Tätigkeitsart",
                    placeholder: "- будь ласка, оберіть -",
                    choice: [
                        {
                            title: "Шкільна освіта",
                            payload: "Шкільна освіта",
                            german: "Schule",
                        },
                        {
                            title: "Навчання",
                            payload: "Навчання",
                            german: "Ausbildung",
                        },
                        {
                            title: "Професійно-технічна освіта",
                            payload: "Професійно-технічна освіта",
                            german: "Fachhochschule",
                        },
                        {
                            title: "Вища освіта",
                            payload: "Вища освіта",
                            german: "Hochschule (Universität)",
                        },
                        {
                            title: "Практика",
                            payload: "Практика",
                            german: "Praktikum",
                        },
                        {
                            title: "Робота",
                            payload: "Робота",
                            german: "Beschäftigung",
                        },
                        {
                            title: "Інше",
                            payload: "Інше",
                            german: "Sonstiges",
                        },
                    ],
                },
                {
                    name: "Початок діяльности",
                    type: "formDate",
                    german: "Tätigkeitsstart",
                },
                {
                    name: "Кінець діяльності",
                    type: "formDate",
                    german: "Tätigkeitsende",
                },
                {
                    name: "Назва діяльності",
                    type: "formInput",
                    german: "Name der Tätigkeitsstätte",
                },
                {
                    name: "Місто діяльності",
                    type: "formInput",
                    german: "Tätigkeitsort (Stadt, Land)",
                },
                {
                    name: "Опис діяльності / Кваліфікація",
                    type: "formText",
                    german: "Tätigkeitsbeschreibung/Qualifikation",
                },
                {
                    title: "Відмінити діяльність",
                    icon: "icon-left-x",
                    payload: "form_ua_20",
                    type: "formButton",
                },
                {
                    title: "Підтвердити діяльність",
                    icon: "icon-left",
                    payload: "form_ua_20",
                    type: "formButton",
                    pageName: "Education",
                    theme: "dark",
                },
            ],
        },
    },
    form_ua_20: {
        botId: "FORM",
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "CV_List",
                    type: "formTable",
                    keyValue: "Education",
                },
                {
                    title: "Новий запис",
                    icon: "icon-left-p",
                    payload: "form_ua_19_1",
                    type: "formButton",
                    theme: "full-right",
                },
                {
                    title: "Підтвердити резюме та продовжити",
                    icon: "icon-right",
                    payload: "form_ua_21",
                    type: "formButton",
                    theme: "dark",
                    stage: "Language",
                },
            ],
        },
    },
    form_ua_21: {
        botId: "FORM",
        messages: [
            {
                type: "infoText",
                text: "Будь ласка, вкажіть Ваші мовні навички.",
                info: "Ваші записи автоматично відображаються в хронологічному порядку. Ви можете ввести до 10 мов.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Мова",
                    type: "formDropdown",
                    german: "Sprache",
                    placeholder: "- будь ласка, оберіть -",
                    choice: [
                        {
                            title: "німецька",
                            payload: "німецька",
                            german: "Deutsch",
                        },
                        {
                            title: "англійська",
                            payload: "англійська",
                            german: "Englisch",
                        },
                        {
                            title: "французька",
                            payload: "французька",
                            german: "Französisch",
                        },
                        {
                            title: "російська",
                            payload: "російська",
                            german: "Russisch",
                        },
                        {
                            title: "український",
                            payload: "український",
                            german: "Ukrainisch",
                        },
                        {
                            title: "іспанська",
                            payload: "іспанська",
                            german: "Spanisch",
                        },
                        {
                            title: "Португальська",
                            payload: "Португальська",
                            german: "Portugiesisch",
                        },
                    ],
                },
                {
                    name: "Sprachkenntnisse",
                    type: "radioButton",
                    choice: [
                        {
                            title: "Базові знання",
                            payload: "Базові знання",
                            german: "Grundkenntnisse",
                        },
                        {
                            title: "Розширені знання",
                            payload: "Розширені знання",
                            german: "Erweiterte Kenntnisse",
                        },
                        {
                            title: "Вільне володіння",
                            payload: "Вільне володіння",
                            german: "Verhandlungssichere Kenntnisse",
                        },
                        {
                            title: "Рідна мова",
                            payload: "Рідна мова",
                            german: "Muttersprache",
                        },
                    ],
                },
                {
                    title: "Скасувати",
                    icon: "icon-left-x",
                    payload: "form_ua_21",
                    type: "formButton",
                },
                {
                    title: "Підтвердити",
                    icon: "icon-left",
                    payload: "form_ua_22",
                    type: "formButton",
                    pageName: "Language",
                    theme: "dark",
                },
            ],
        },
    },
    form_ua_21_1: {
        botId: "FORM",
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Мова",
                    type: "formDropdown",
                    german: "Sprache",
                    placeholder: "- будь ласка, оберіть -",
                    choice: [
                        {
                            title: "німецька",
                            payload: "німецька",
                            german: "Deutsch",
                        },
                        {
                            title: "англійська",
                            payload: "англійська",
                            german: "Englisch",
                        },
                        {
                            title: "французька",
                            payload: "французька",
                            german: "Französisch",
                        },
                        {
                            title: "російська",
                            payload: "російська",
                            german: "Russisch",
                        },
                        {
                            title: "український",
                            payload: "український",
                            german: "Ukrainisch",
                        },
                        {
                            title: "іспанська",
                            payload: "іспанська",
                            german: "Spanisch",
                        },
                        {
                            title: "Португальська",
                            payload: "Португальська",
                            german: "Portugiesisch",
                        },
                    ],
                },
                {
                    name: "Sprachkenntnisse",
                    type: "radioButton",
                    choice: [
                        {
                            title: "Базові знання",
                            payload: "Базові знання",
                            german: "Grundkenntnisse",
                        },
                        {
                            title: "Розширені знання",
                            payload: "Розширені знання",
                            german: "Erweiterte Kenntnisse",
                        },
                        {
                            title: "Вільне володіння",
                            payload: "Вільне володіння",
                            german: "Verhandlungssichere Kenntnisse",
                        },
                        {
                            title: "Рідна мова",
                            payload: "Рідна мова",
                            german: "Muttersprache",
                        },
                    ],
                },
                {
                    title: "Скасувати",
                    icon: "icon-left-x",
                    payload: "form_ua_22",
                    type: "formButton",
                },
                {
                    title: "Підтвердити",
                    icon: "icon-left",
                    payload: "form_ua_22",
                    type: "formButton",
                    pageName: "Language",
                    theme: "dark",
                },
            ],
        },
    },
    form_ua_22: {
        botId: "FORM",
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Sprachen Liste",
                    type: "formTable",
                    keyValue: "Language",
                },
                {
                    title: "Новий запис",
                    icon: "icon-left-p",
                    payload: "form_ua_21_1",
                    type: "formButton",
                    theme: "full-right",
                },
                {
                    title: "Підтвердити мови та надіслати форму",
                    payload: "send_form",
                    type: "formButton",
                    pageName: "FormularAbschluss",
                    theme: "dark",
                    stage: "Finish",
                },
            ],
        },
    },
    send_form: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Дякуємо, ми створили Ваш документ! <br>Тепер Ви можете закрити майстер.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [],
        },
    },
};
